import React, { useEffect } from 'react';
import { formatCurrency } from '../../helpers/currencies';
const AddOnsSelector = ({ monogrammingBasePrice, monogrammingActive, addOns, currentAddOns, strings, goToAddOn }) => {
    useEffect(() => {
        const placeholders = document.querySelectorAll('.product__add-ons--wrapper');
        if (placeholders) {
            placeholders.forEach((placeholder) => (placeholder.style.display = 'none'));
        }
    }, []);
    return (React.createElement("div", { className: "fg-cust--add-ons" },
        monogrammingBasePrice != null && (React.createElement("button", { className: `fg-cust--add-ons__button variant-button ${monogrammingActive ? 'selected' : ''}`, onClick: () => goToAddOn('monogramming', 0) },
            React.createElement("span", { className: "fg-cust--add-ons__button--title" }, strings.monogram_title),
            React.createElement("span", { className: "fg-cust--add-ons__button--price" }, monogrammingBasePrice == 0 ? strings.promo_monogramming : formatCurrency(monogrammingBasePrice)))),
        addOns.map((addOn, index) => {
            return (React.createElement("button", { key: `add-on--${index}`, className: `fg-cust--add-ons__button variant-button ${currentAddOns.find((item) => item.part_type == addOn.part_type) ? 'selected' : ''}`, onClick: () => goToAddOn('add-on', index) },
                React.createElement("span", { className: "fg-cust--add-ons__button--title" }, addOn.title),
                React.createElement("span", { className: "fg-cust--add-ons__button--price" }, formatCurrency(addOn.price))));
        })));
};
export default AddOnsSelector;
